<template>
  <div class="modelReg">
    <div class="modelReg__grid">
      <div class="modelReg__title">
        <h3>🔔 Уведомления</h3>
        <p>Получайте актуальную информацию о заказах и акциях</p>
      </div>

      <div v-if="isLoading" class="modelReg__alertLoading"></div>

      <div class="push-notification-content">

        <div class="benefits-list">
          <div class="benefit-item">
            <UIcon name="i-heroicons-shopping-cart" class="benefit-icon" />
            <span>Статус заказа и готовность</span>
          </div>
          <div class="benefit-item">
            <UIcon name="i-heroicons-tag" class="benefit-icon" />
            <span>Специальные предложения и скидки</span>
          </div>
          <div class="benefit-item">
            <UIcon name="i-heroicons-megaphone" class="benefit-icon" />
            <span>Новости и акции ресторана</span>
          </div>
          <div class="benefit-item">
            <UIcon name="i-heroicons-gift" class="benefit-icon" />
            <span>Персональные бонусы</span>
          </div>
        </div>

        <p class="description">
          Вы всегда сможете отключить уведомления в настройках профиля
        </p>
      </div>

      <div class="modelReg__grid-btn">
        <UiButtonMain
          size="xl"
          color="red"
          :label="isLoading ? 'Настраиваем...' : 'Включить уведомления'"
          :disabled="isLoading"
          @click="enableNotifications"
        />

        <UiButtonMain
          size="xl"
          variant="outline"
          label="Пропустить"
          :disabled="isLoading"
          @click="skipNotifications"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { consola } from 'consola'
import { useModalStore } from '@shared/model'

const logger = consola.withTag('PushNotificationPermissionModal')

const modalStore = useModalStore()

const isMobileApp = (): boolean => {
  try {
    return typeof window !== 'undefined' && Boolean(window.Capacitor?.isNativePlatform?.())
  } catch {
    return false
  }
}

// Если не мобильное приложение, закрываем модальное окно
if (!isMobileApp()) {
  logger.log('🔔 [MODAL] Not a mobile app, closing push notification modal')
  modalStore.close()
}
const isLoading = ref(false)

const enableNotifications = async () => {
  isLoading.value = true

  try {
    // Получаем storage для сохранения настроек
    const storageModule = await import('@features/notifications')
    const storage = storageModule.usePushNotificationStorage()

    // Вызываем глобальную функцию инициализации push notifications
    if (typeof globalThis.initPushNotificationsAfterAuth === 'function') {
      const success = await globalThis.initPushNotificationsAfterAuth()

      if (success) {
        // Сохраняем настройку пользователя через правильное хранилище
        await storage.setPushEnabled(true)
        await storage.setPushAsked(true)

        // Показываем успешное сообщение
        logger.log('🔔 Push notifications enabled successfully')
      } else {
        // Пользователь отклонил системные разрешения
        logger.warn('🔔 Push notifications permission denied by user')
        await storage.setPushEnabled(false)
        await storage.setPushAsked(true)
      }
    }
  } catch (error) {
    logger.error('🔔 Error enabling push notifications:', error)
  }
  isLoading.value = false
  modalStore.close()
}

const skipNotifications = async () => {
  // Сохраняем что пользователь отказался
  const storageModule = await import('@features/notifications')
  const storage = storageModule.usePushNotificationStorage()

  await storage.setPushEnabled(false)
  await storage.setPushAsked(true)

  logger.log('🔔 User skipped push notifications')
  modalStore.close()
}
</script>

<style scoped lang="scss">
.push-notification-content {
  @apply grid gap-6 text-center;
}

.notification-icon {
  @apply flex justify-center mb-4;
}

.bell-icon {
  @apply w-16 h-16 text-sky-500;
}

.benefits-list {
  @apply grid gap-3 text-left;
}

.benefit-item {
  @apply flex items-center gap-3;
}

.benefit-icon {
  @apply w-5 h-5 text-sky-500 flex-shrink-0;
}

.benefit-item span {
  @apply text-gray-700 dark:text-gray-300 text-sm;
}

.description {
  @apply text-xs text-gray-500 dark:text-gray-400 leading-relaxed;
}

.modelReg__grid-btn{
  @apply grid gap-6;
}
</style>
